module.exports = __webpack_public_path__ + "assets/img/stream-glas.b84c95bb.png";